<template>
  <div class="remove__list">
    <span>
      {{ $t("list.messages.select_list_or_chat") }}
    </span>
  </div>
</template>

<script>
import { EventEmitter } from "../main";

export default {
  mounted() {
    setTimeout(() => {
      let data = {
        type: "no_list",
        data: {
          text: this.$t("list.messages.not_exist"),
          cancel: this.$t("app.alert.close"),
          delete: "",
        },
        list: "",
      };
      EventEmitter.$emit("OpenPopup", data);
    }, 100);
  },
};
</script>
